/**
 * Session Summary Cards Component
 * Displays overview statistics for session history
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';

const SessionSummaryCards = ({ summary }) => {
  if (!summary?.summary) return null;

  const stats = [
    {
      label: 'Total Sessions',
      value: summary.summary.total_sessions || 0,
      color: 'text-blue-600'
    },
    {
      label: 'Completed',
      value: summary.summary.completed_sessions || 0,
      color: 'text-green-600'
    },
    {
      label: 'Total Duration',
      value: `${Math.round((summary.summary.total_duration_minutes || 0) / 60)}h`,
      color: 'text-purple-600'
    },
    {
      label: 'Total Earnings',
      value: `₹${(summary.summary.total_earnings || 0).toLocaleString()}`,
      color: 'text-amber-600'
    }
  ];

  return (
    <div className="grid grid-cols-4 gap-4 mb-6">
      {stats.map((stat, idx) => (
        <Card key={idx}>
          <CardContent className="p-4">
            <p className="text-sm text-gray-500">{stat.label}</p>
            <p className={`text-2xl font-bold ${stat.color}`}>{stat.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default SessionSummaryCards;
